import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Client } from '@shared/entities/client';
import { ClientFilter } from '@shared/entities/clientFilter';
import { LAST_FINAL_USER_SEEN_KEY_STORAGE } from '@shared/models/constants';
import { FilterSelectedEventType } from '@shared/models/types';
import { ClientFiltersService } from '@shared/services/api/client-filters.service';
import { ClientFilterURL, ClientService } from '@shared/services/api/client.service';
import { ProfileService } from '@shared/services/api/profile.service';
import { Observable, first, of, shareReplay, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-final-users',
  templateUrl: './final-users.component.html',
  styleUrl: './final-users.component.scss'
})
export class FinalUsersComponent {
  clients$: Observable<Client[]>;
  clientFilters$: Observable<ClientFilter>;
  prevPage?: number = undefined;
  currentPage?: number = 1;
  nextPage?: number = undefined;
  lastFinalUserSeen$: Observable<Client[] | null>;

  constructor(
    public translateService: TranslateService,
    private _clientService: ClientService,
    private _clientFiltersService: ClientFiltersService,
    private _profileService: ProfileService
  ) {
    this.lastFinalUserSeen$ = this._profileService.profile$.pipe(
      first(),
      switchMap((profile) => {
        const userToParse = localStorage.getItem(`${LAST_FINAL_USER_SEEN_KEY_STORAGE}_${profile.id}`);
        return userToParse ? of([JSON.parse(userToParse)]) : of(null);
      }),
      shareReplay(1)
    );

    this.clientFilters$ = this._clientFiltersService.all$;
    this.clients$ = this._clientService.all$.pipe(
      switchMap((pagination) => {
        this.prevPage = pagination.prevPage;
        this.currentPage = pagination.currentPage;
        this.nextPage = pagination.nextPage;
        return of(pagination.data);
      })
    );
  }

  onSelectedFilter(filters: FilterSelectedEventType[]) {
    const filtersName = filters.reduce((acc: any, filter: FilterSelectedEventType) => {
      acc[filter.name] = filter.selectedValue;
      return acc;
    }, {});
    this._clientService.filters = filtersName as ClientFilterURL;
  }

  onChangePage(page: number) {
    this._clientService.refresh(page).pipe(
      tap((pagination) => {
        this.prevPage = pagination.prevPage;
        this.currentPage = pagination.currentPage;
        this.nextPage = pagination.nextPage;
      })
    );
  }

  getYear() {
    return new Date().getFullYear();
  }
}
